@if (templateList) {
<div class="right-block">
  <div class="widget-body">
    <div class="widget-toolbox" fxLayout="row" fxLayoutAlign="start center">
      <h4>Template List</h4>
    </div>
    <div class="widget-main">
      @for (ttl of templateList; track ttl; let i = $index) {
      <ul class="nav-list">
        <li
          class="sub-menu"
          (click)="onClickTemplate(ttl.templateKey)"
          [ngClass]="{
            active: ttl.templateKey == this.currentItem,
            bold: ttl.activeStatus
          }"
          [matTooltip]="ttl.activeStatus ? 'Current active template' : null"
          matTooltipClass="tooltip2"
        >
          {{ ttl.templateName }}@if (ttl.activeStatus) {
          <span>*</span>
          }
        </li>
      </ul>
      }
    </div>
  </div>
</div>
} @else { No Data Available }
